export default {
  SMS: "sms",
  NET: "net",
  IOT: "iot",
  LX_IOT: "lx_iot"
};
